// The frontend's settings. A deployed site loads them when it starts, from /env.js (written
// by the web container from its environment — infra/web/40-env-js.sh), so one built image
// serves staging and production. Without /env.js values (npm start, Jest) they come from the
// REACT_APP_* variables compiled in at build time, as before.
//
// Read settings from here, never from process.env directly. To add one: list it below and in
// infra/web/40-env-js.sh.
type Settings = Partial<Record<string, string>>;

const runtime: Settings =
  (typeof window !== 'undefined' && (window as unknown as { __ENV__?: Settings }).__ENV__) || {};

// Create React App only compiles in variables it sees written out in full, so each is named.
export const env = {
  REACT_APP_API_URL: runtime.REACT_APP_API_URL ?? process.env.REACT_APP_API_URL,
  REACT_APP_STRIPE_PUBLISHABLE_KEY:
    runtime.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  REACT_APP_PAYMENT_TERMS_VERSION:
    runtime.REACT_APP_PAYMENT_TERMS_VERSION ?? process.env.REACT_APP_PAYMENT_TERMS_VERSION,
  REACT_APP_PAYMENT_TERMS_URL:
    runtime.REACT_APP_PAYMENT_TERMS_URL ?? process.env.REACT_APP_PAYMENT_TERMS_URL,
  REACT_APP_SMS_DISABLED: runtime.REACT_APP_SMS_DISABLED ?? process.env.REACT_APP_SMS_DISABLED,
  REACT_APP_DISABLE_PHONE_VALIDATION:
    runtime.REACT_APP_DISABLE_PHONE_VALIDATION ?? process.env.REACT_APP_DISABLE_PHONE_VALIDATION,
  REACT_APP_ENABLE_PAYMENTS:
    runtime.REACT_APP_ENABLE_PAYMENTS ?? process.env.REACT_APP_ENABLE_PAYMENTS,
  REACT_APP_HERO_VIDEOS: runtime.REACT_APP_HERO_VIDEOS ?? process.env.REACT_APP_HERO_VIDEOS,
  REACT_APP_ANALYTICS_DEBUG_IP:
    runtime.REACT_APP_ANALYTICS_DEBUG_IP ?? process.env.REACT_APP_ANALYTICS_DEBUG_IP,
};
